import React, { useMemo, useRef } from 'react'
import { Typography, Tooltip, SvgIcon } from '@mui/material'
import { HelpOutlineOutlined } from '@mui/icons-material'

import { PopperComponent } from 'components'

import { DisplayHeaderContainerStyles } from './DisplayHeader.styles'
import { DisplayHeaderPropTypes } from './DisplayHeader.types'

export const DisplayHeaderComponent: React.FC<DisplayHeaderPropTypes> = ({
  title,
  showHelperIcon
}) => {
  const titleRef = useRef<HTMLParagraphElement>(null)

  const isEllipsisActivated = useMemo(() => {
    if (!titleRef.current) return false

    const { offsetWidth, scrollWidth } = titleRef.current

    return offsetWidth < scrollWidth
  }, [titleRef.current?.offsetWidth, titleRef.current?.scrollWidth])

  return (
    <Tooltip
      title={title}
      placement='top'
      disableHoverListener={!isEllipsisActivated}
      arrow
    >
      <DisplayHeaderContainerStyles>
        <Typography
          noWrap
          ref={titleRef}
          variant='body2'
          fontWeight={(theme) => theme.typography.fontWeightBold}
        >
          {title}
        </Typography>
        {showHelperIcon && (
          <PopperComponent {...showHelperIcon}>
            {showHelperIcon.helperIcon ? (
              React.createElement('span', showHelperIcon)
            ) : (
              <SvgIcon
                cursor='help'
                component={HelpOutlineOutlined}
                color='info'
                sx={{ fontSize: 16 }}
              />
            )}
          </PopperComponent>
        )}
      </DisplayHeaderContainerStyles>
    </Tooltip>
  )
}

export * from './DisplayHeader.types'
